import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDailyLedgerApi } from "../../../apiservice/reports";

export const fetchDailyLedger = createAsyncThunk(
  "dailyLedger/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        dateFrom: filters?.fromDate || null,
        dateTo: filters?.toDate || null,
      };
      const res = await getDailyLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
